<template>
  <responsive-modal v-model="visible" size="lg">
    <div class="tool-modal-rdstation p-5">
      <button
        class="btn text-secondary close"
        @click="
          visible = false;
          clear();
        "
      >
        <i class="icon-x" />
      </button>
      <div>
        <strong>
          Integração RD Station Marketing
        </strong>
      </div>
      <div class="d-flex align-items-center pt-5">
        <small class="text-dark">
          <a
            target="_blank"
            href="https://www.rdstation.com/produtos/marketing/"
            class="text-primary font-weight-bold text-decoration-none"
          >
            Conheça o RD Station Marketing
          </a>
        </small>
        <a
          class="fa-solid fa-arrow-up-right-from-square ml-3"
          target="_blank"
          href="https://www.rdstation.com/produtos/marketing/"
        ></a>
      </div>
      <hr />
      <small>URL de redirecionamento:</small>
      <br />
      <div class="d-flex justify-content-between">
        <button
          class="btn d-flex align-items-center justify-content-start
                  small text-primary text-decoration-none px-0"
          @click="copyUrl(callback_url)"
        >
          {{ callback_url }}
        </button>
        <button
          class="btn btn-sm text-primary text-decoration-none"
          @click="copyUrl(callback_url)"
        >
          <i class="fa-solid fa-link"></i>
          <span class="ml-3">Copiar URL</span>
        </button>
      </div>
      <bp-input
        id="client_id"
        label="Client ID"
        :limit="36"
        v-model="form.client_id"
        placeholder="Digite o client_id da integração..."
        :errors="errors.client_id"
      />
      <bp-input
        id="client_secret"
        label="Client Secret"
        :limit="32"
        v-model="form.client_secret"
        placeholder="Digite o client_secret da integração..."
        :errors="errors.client_secret"
      />
      <div class="d-flex justify-content-center mt-5">
        <button
          class="btn btn-primary"
          :disabled="!isValid"
          :class="{
            'btn-secondary': !isValid
          }"
          @click="submit"
        >
          <loading :show="loading">
            Salvar
          </loading>
        </button>
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ...formFields(["client_id", "client_secret"], {
        client_id: "",
        client_secret: ""
      }),
      loading: false,
      visible: false,
      callback_url:
        "https://api.velora.com.br/v1/integrations/rd-station/callback"
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      }
    }
  },
  computed: {
    ...mapState("integration", ["integrationList"]),
    ...mapState("product", ["products"]),
    isValid() {
      return this.form.client_id && this.form.client_secret !== undefined;
    }
  },
  methods: {
    clear() {
      this.form = {};
      this.$emit("clear-edit");
    },
    submit() {
      this.loading = true;
      let data = { ...this.form };
      let action = "integration/postIntegration";
      this.$store
        .dispatch(action, data)
        .then(object => {
          this.$message.success("Integração salva");
          this.clear();
          this.loading = false;
          this.visible = false;
        })
        .catch(error => {
          this.$message.error("Erro ao salvar integração");
          this.errors = error.response.data;
          this.loading = false;
        })
        .finally(() => {});
    },
    copyUrl(i) {
      navigator.clipboard.writeText(i);
      this.$message.success("Url copiada.");
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep.fit-scroll-content {
  max-height: unset !important;
}

.tool-modal-rdstation {
  position: relative;
  .close {
    position: absolute;
    top: 0;
    right: 0;
  }

  button {
    i {
      font-size: 20px;
    }
  }
}
</style>
